var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseModule',_vm._b({staticClass:"embed-google-maps",attrs:{"data-module":"google-maps"}},'BaseModule',_vm.$props,false),[_c('CustomHTML',_vm._b({attrs:{"html":_vm.embedCode}},'CustomHTML',_vm.$props,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }